<template>
  <div class="form-group with-icon-right-mod">
    <div class="input-group">
      <vuestic-date-picker :id="idInput" :name="idInput" v-model="datepicker.simple" :config="{enableTime}"/>
      <i :class="'fa icon-left input-icon '+iconInput"></i>
      <i class="fa fa-times icon-right input-icon pointer" @click="clear()"></i>
      <label class="control-label" :for="idInput">{{labelInput}}</label><i class="bar"></i>
      <small class="help text-secondary">
        <slot></slot>
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DateIconGroup',
  props: ['idInput', 'iconInput', 'labelInput', 'inputValue', 'enableTime'],
  data () {
    return {
      datepicker: {
        simple: this.inputValue
      }
    }
  },
  methods: {
    clear () {
      document.getElementById(this.idInput).value = ''
    }
  }
}
</script>

<style scoped>

</style>
